export interface Referral {
  id: number | null;
  earned: number | null;
  image: string | null;
  title: string | null;
  description: string | null;
  referee?: string | null;
  price: number | null;
  purchaseDate: string | null;
  reservationDate: string | null;
  time: string | null;
  customerName: string | null;
  customerPhone: string | null;
  customerEmail: string | null;
}

export interface ReferralsProps {
  data: Referral[];
}

export enum BookingsAndReferralsTab {
  Bookings = "Bookings",
  Referrals = "Referrals",
}
